export const travelDurationHoursToSeconds = (durationInHours) => {
  const seconds = Math.round(Number(durationInHours) * 3600);

  return Number.isFinite(seconds) && seconds > 0 ? seconds : null;
};
